module.exports = __webpack_public_path__ + "img/ntpp2-2.48c3d45e.png";